export const editorTranslations = {
  name: 'Nome',
  save: 'Salvar',
  saveAs: 'Salvar como',
  back: 'voltar',
  loading: 'Carregando...',
  resetOperations: 'Redefinir tudo',
  changesLoseWarningHint: 'Todas suas alterações serão perdidas. Deseja continuar?',
  discardChangesWarningHint: 'Se você sair, suas alterações não serão salvas.',
  cancel: 'Cancelar',
  apply: 'Aplicar',
  warning: 'Aviso',
  confirm: 'Confirmar',
  discardChanges: 'Descartar alterações',
  undoTitle: 'Desfazer',
  redoTitle: 'Refazer',
  showImageTitle: 'Mostrar imagem original',
  zoomInTitle: 'Ampliar',
  zoomOutTitle: 'Reduzir',
  toggleZoomMenuTitle: 'Alternar menu de zoom',
  adjustTab: 'Ajustar',
  finetuneTab: 'Refinar',
  filtersTab: 'Filtros',
  watermarkTab: "Marca d'água",
  annotateTabLabel: 'Desenhar',
  resize: 'Redimensionar',
  resizeTab: 'Redimensionar',
  imageName: 'Nome da imagem',
  invalidImageError: 'Imagem fornecida inválida.',
  uploadImageError: 'Erro ao fazer upload da imagem.',
  areNotImages: 'não são imagens',
  isNotImage: 'não é uma imagem',
  toBeUploaded: 'para ser enviado',
  cropTool: 'Cortar',
  original: 'Original',
  custom: 'Personalizado',
  square: 'Quadrado',
  landscape: 'Paisagem',
  portrait: 'Retrato',
  ellipse: 'Elipse',
  classicTv: 'TV clássica',
  cinemascope: 'Cinemascope',
  arrowTool: 'Seta',
  blurTool: 'Desfocar',
  brightnessTool: 'Brilho',
  contrastTool: 'Contraste',
  ellipseTool: 'Elipse',
  unFlipX: 'Desvirar X',
  flipX: 'Virar X',
  unFlipY: 'Desvirar Y',
  flipY: 'Virar Y',
  hsvTool: 'HSV',
  hue: 'Matiz',
  brightness: 'Brilho',
  saturation: 'Saturação',
  value: 'Valor',
  imageTool: 'Imagem',
  importing: 'Importando...',
  addImage: '+ Adicionar imagem',
  uploadImage: 'Fazer upload de imagem',
  fromGallery: 'Da galeria',
  lineTool: 'Linha',
  penTool: 'Caneta',
  polygonTool: 'Polígono',
  sides: 'Lados',
  rectangleTool: 'Retângulo',
  cornerRadius: 'Raio do canto',
  resizeWidthTitle: 'Largura em pixels',
  resizeHeightTitle: 'Altura em pixels',
  toggleRatioLockTitle: 'Alternar trava de proporção',
  resetSize: 'Redefinir para tamanho original da imagem',
  rotateTool: 'Girar',
  textTool: 'Texto',
  textSpacings: 'Espaçamentos de texto',
  textAlignment: 'Alinhamento do texto',
  fontFamily: 'Família da fonte',
  size: 'Tamanho',
  letterSpacing: 'Espaçamento entre letras',
  lineHeight: 'Altura da linha',
  warmthTool: 'Calor',
  addWatermark: "+ Adicionar marca d'água",
  addTextWatermark: "+ Adicionar marca d'água de texto",
  addWatermarkTitle: "Escolha o tipo de marca d'água",
  uploadWatermark: "Fazer upload de marca d'água",
  addWatermarkAsText: 'Adicionar como texto',
  padding: 'Preenchimento',
  paddings: 'Preenchimentos',
  shadow: 'Sombra',
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  blur: 'Desfoque',
  opacity: 'Opacidade',
  transparency: 'Transparência',
  position: 'Posição',
  stroke: 'Traçado',
  saveAsModalTitle: 'Salvar como',
  extension: 'Extensão',
  format: 'Formato',
  nameIsRequired: 'O nome é obrigatório.',
  quality: 'Qualidade',
  imageDimensionsHoverTitle: 'Tamanho da imagem salva (largura x altura)',
  cropSizeLowerThanResizedWarning:
    'Nota, a área de corte selecionada é menor que o redimensionamento aplicado, o que pode causar diminuição da qualidade',
  actualSize: 'Tamanho real (100%)',
  fitSize: 'Ajustar tamanho',
  addImageTitle: 'Selecione a imagem para adicionar...',
  mutualizedFailedToLoadImg: 'Falha ao carregar a imagem.',
  tabsMenu: 'Menu',
  download: 'Baixar',
  width: 'Largura',
  height: 'Altura',
  plus: '+',
  cropItemNoEffect: 'Nenhuma pré-visualização disponível para este item de corte',
};
